import styled from '@emotion/styled';

export const BaseCarouselPagerWrapper = styled.div`
  position: absolute;
  margin-left: 50%;
  transform: translateX(-50%);
  bottom: ${({ theme }) => theme.spacing(3)};
`;
